import { Locales } from './locales';

import nl from './nl.json';
import en from './en.json';

export const messages = {
  [Locales.NL]: nl,
  [Locales.EN]: en,
};

export const locale = Locales.NL;
export const defaultLocale = Locales.NL;
